import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderState } from './loader';
import { PAGINATION_CONTROL_VALUE_ACCESSOR } from 'ngx-bootstrap/pagination/pagination.component';

@Injectable()

/*
* Service to show and hide loading icon
*/
export class LoaderService {

    private loaderSubject = new Subject<LoaderState>();

    loaderState = this.loaderSubject.asObservable();

    constructor() {
    }

    show(): void {
        this.loaderSubject.next(<LoaderState>{ show: true });
    }

    hide(): void {
        this.loaderSubject.next(<LoaderState>{ show: false });
    }
}